import { endpointsList } from '@/helpers';
import axios from 'axios';

export class DocumentsService {
  public static async getSupplierDocumentTitle(
    documentOid: string,
  ): Promise<string> {
    const response = await axios.get<string>(
      endpointsList.documentsUploads.getDocumentTitle(documentOid),
    );
    return response.data;
  }

  public static async getDigitalizationDocumentTitle(
    documentOid: string,
  ): Promise<string> {
    const response = await axios.get<string>(
      endpointsList.digitalizationUploads.getDocumentTitle(documentOid),
    );
    return response.data;
  }
}
